import { toRem, toRems } from "../../../../helpers/theme";
import { isNumeric, normalizeDimension } from "../../../../helpers/utils";

const style = ({ theme, itemsSpacing, hasMarginTop, paddingBottom, isDishTags }) => {
    const itemSpacing = isNumeric(itemsSpacing) ? normalizeDimension(itemsSpacing) : 0;

    return {
        ...(hasMarginTop && {
            marginTop: toRem(40),
        }),
        ...(paddingBottom && {
            paddingBottom: toRem(paddingBottom),
        }),
        "& .tagPills": {
            "&_title": {
                margin: toRems([0, 0, 12, 0]),
                padding: 0,
                fontWeight: theme.typography.fontWeight.black,
                fontSize: toRem(16),
                lineHeight: 1.2,
                [theme.breakpoints.up("md")]: {
                    margin: toRems([0, 0, 20, 0]),
                },
            },
            "&_list": {
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                marginBottom: toRem(-itemSpacing),
                "&Item": {
                    display: "flex",
                    margin: toRems([0, itemSpacing, itemSpacing, 0]),
                },
            },
            "&_cta": {
                // this sucks
                fontWeight: theme.typography.fontWeight.regular,
                fontSize: isDishTags ? toRem(18) : toRem(14),
                padding: isDishTags ? toRems([6, 12, 8]) : toRems([5, 8, 6]),
                borderWidth: 1,
                "&.isMore": {
                    color: theme.colors.button?.tertiary?.text?.hover,
                },
            },
        },
    };
};

export default style;
